import { render, staticRenderFns } from "./ProductCategoryDelete.vue?vue&type=template&id=52ff290c"
import script from "./ProductCategoryDelete.vue?vue&type=script&lang=js"
export * from "./ProductCategoryDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports